module.exports = __webpack_public_path__ + "static/6-challenges-for-ceos.2782d9e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/presentations/6-challenges-for-ceos.jpg
// module id = 199
// module chunks = 35783957827783 267625579013595